import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

import * as styles from "./LogoBoard.module.css";

const LogoBoard = ({ logos }) => {
  return (
    <ul className={styles.logoBoard}>
      {logos.map(({ file, title: imageTitle, gatsbyImageData }) => {
        let renderLogo;
        if (file.contentType === "image/svg+xml") {
          renderLogo = (
            <img src={file.url} alt={imageTitle} title={imageTitle} />
          );
        } else {
          renderLogo = (
            <GatsbyImage
              image={gatsbyImageData}
              alt={imageTitle || ""}
              title={imageTitle}
            />
          );
        }
        return (
          <li key={imageTitle}>
            <div className={styles.logo}>{renderLogo}</div>
          </li>
        );
      })}
    </ul>
  );
};

export default LogoBoard;
